import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Target, Sparkles } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function TransformationSection() {
  return <section className="py-20 md:py-28 px-4 bg-cream relative" data-id="element-214">
      <div className="max-w-5xl mx-auto" data-id="element-215">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16" data-id="element-216">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} data-id="element-217">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-highlight/30 text-nude-dark font-bold text-sm mb-6" data-id="element-218">
              <span className="animate-pulse" data-id="element-219">🔥</span>
              <span data-id="element-220">Tu nueva vida</span>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-2 leading-tight" data-id="element-221">
              Imaginá despertarte en 30 días y no reconocerte.
            </h2>

            <p className="text-2xl md:text-3xl text-cta italic font-serif mb-6" data-id="element-222">
              Más fuerte. Más enfocado/a. Más seguro/a. Imparable.
            </p>

            <p className="text-lg text-secondary mb-6 leading-relaxed" data-id="element-223">
              Un ebook práctico y directo que te guía paso a paso para
              transformar tu vida desde lo más importante:{' '}
              <strong data-id="element-224">tus hábitos diarios.</strong>
            </p>

            <div className="bg-white p-6 rounded-2xl shadow-soft border border-border mb-6" data-id="element-225">
              <p className="text-primary font-medium mb-2 flex items-center gap-2" data-id="element-226">
                <Target className="w-5 h-5 text-cta" data-id="element-227" />
                Este no es otro contenido motivacional.
              </p>
              <p className="text-secondary" data-id="element-228">
                No depende de que "tengas ganas". Es un sistema simple, claro y
                aplicable que te muestra exactamente qué hacer cada día para
                empezar a cambiar de verdad.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-229">
            {/* Visual representation of transformation */}
            <div className="flex flex-col gap-4 relative z-10" data-id="element-230">
              {/* Before State */}
              <div className="bg-beige p-6 rounded-2xl border border-border/50 opacity-70 grayscale-[30%]" data-id="element-231">
                <h3 className="font-bold text-primary mb-2 flex items-center gap-2" data-id="element-232">
                  <span className="w-2 h-2 rounded-full bg-red-400" data-id="element-233"></span>
                  HOY
                </h3>
                <p className="text-sm text-secondary" data-id="element-234">
                  Te sentís estancado/a, sin energía, repitiendo los mismos
                  errores, viendo pasar los días sin avanzar.
                </p>
              </div>

              {/* Arrow */}
              <div className="flex justify-center -my-2 relative z-20" data-id="element-235">
                <div className="bg-cta text-white p-2 rounded-full shadow-lg" data-id="element-236">
                  <ArrowRight className="w-6 h-6 rotate-90 lg:rotate-0" data-id="element-237" />
                </div>
              </div>

              {/* After State */}
              <div className="bg-white p-8 rounded-2xl shadow-soft border-2 border-highlight transform scale-105" data-id="element-238">
                <h3 className="font-bold text-primary mb-2 text-lg flex items-center gap-2" data-id="element-239">
                  <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-240"></span>
                  EN 30 DÍAS
                </h3>
                <p className="text-secondary" data-id="element-241">
                  Te levantás con propósito. Tenés control. Tu cuerpo cambia. Tu
                  mente está clara. La gente a tu alrededor lo nota.
                </p>
              </div>
            </div>

            {/* Decorative blob */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-highlight/20 blur-3xl rounded-full -z-10" data-id="element-242"></div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-243">
          <CTAButton text="Quiero empezar mi transformación" data-id="element-244" />
        </motion.div>
      </div>
    </section>;
}